import { Typography } from '@mui/material';
import React from 'react';
import Data from '../../Data/PersonalInfo.json';

// @ desc `What I want`
const Outro = () => {
  return (
    <>
      {Data.about.map((data, i) => (
        <Typography variant='paragraph' key={i}>
          {data.outro}
        </Typography>
      ))}
    </>
  );
};

export default Outro;
